import PartnersQuery from '@queries/PartnerPagination'
import * as types from '@store/types'
import request from '@queries'

const state = {
  pagination: { list: [] }
}

const getters = {
  [types.PARTNER_PAGINATION]: ({ pagination }) => ({ ...pagination })
}

const mutations = {
  [types.PARTNER_PAGINATION]: (state, payload) => {
    state.pagination = { ...payload }
  }
}

const actions = {
  [types.PARTNER_PAGINATION]: async ({ commit }, variables) => {
    const response = await request(PartnersQuery, { ...variables })
    commit(types.PARTNER_PAGINATION, response.data.data.partners || { })
  }
}

export default { state, getters, mutations, actions }



// WEBPACK FOOTER //
// ./src/store/modules/partner.js